module.exports = __webpack_public_path__ + "static/media/stopwatch.e165b756.svg";